import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

const Section = ({ title, titleId, titleProps, loading = false, subtitle = null, slots = {}, slotProps, children }) => {
  const resolvedTitle = titleId ? <FormattedMessage id={titleId} /> : title;
  const hasTitle = loading || (resolvedTitle != null && resolvedTitle !== '');
  const hasAside = Boolean(slots?.aside);
  const hasHeader = hasTitle || hasAside || Boolean(subtitle);

  return (
    <Stack spacing={1.5}>
      {hasHeader && (
        <Stack
          data-testid="section-primary"
          direction={hasAside ? 'row' : 'column'}
          alignItems={hasAside ? 'center' : undefined}
          justifyContent={hasAside ? 'space-between' : undefined}
          paddingX={2}
          marginBottom={slots?.end ? 4 : 0}
          {...slotProps?.primary}
        >
          <Stack spacing={1} flexGrow={1}>
            {hasTitle && (
              <Heading component="h2" color="primary" size="xl" weight="medium" loading={loading} {...titleProps}>
                {resolvedTitle}
              </Heading>
            )}
            {subtitle}
          </Stack>
          {hasAside && slots.aside}
        </Stack>
      )}
      {slots?.end}
      <Box paddingX={2}>{children}</Box>
    </Stack>
  );
};

Section.propTypes = {
  title: PropTypes.node,
  titleId: PropTypes.string,
  titleProps: PropTypes.shape({}),
  loading: PropTypes.bool,
  subtitle: PropTypes.node,
  slots: PropTypes.shape({
    end: PropTypes.node,
    aside: PropTypes.node,
  }),
  slotProps: PropTypes.shape({
    primary: PropTypes.shape({}),
  }),
  children: PropTypes.node.isRequired,
};

export default Section;
